import { tranStr } from "../../../utils/translation";
import { authHeader } from "../../../_helpers/auth-header";
import { sharedAPIs } from "../../../api/api-endpoints/SharedServiceEndpoints";

import { AutoCloseModal } from "../../modal/Modal";

export async function saveLocationFactors(data) {
  const { locationFactors } = data;

  if (data.fields === null) {
    return data.setError({
      text: tranStr("Please enter location factor"),
      type: "feedback-error",
    });
  }

  data.setError({
    text: tranStr("Saving..."),
    type: "feedback-success",
  });

  const payload = JSON.stringify({
    location_factors: data.fields,
    region: data.region,
    country: data.country,
  });

  const url = sharedAPIs().save_location_factors;

  const config = {
    method: "POST",
    body: payload,
    headers: authHeader({
      authJson: true,
      authForm: false,
      guestJson: false,
    }),
  };

  let response = await fetch(url, config);
  if (response.ok) {
    locationFactors.set(await locationFactors.get());
    // Response OK
    return data.setError({
      text: "Saved Successfully",
      type: "feedback-success",
    });
  } else {
    // Response Not OK
    return data.setError({
      text: "Save Failed",
      type: "feedback-error",
    });
  }
}

export async function uploadFile(
  region,
  country,
  setError,
  file,
  locationFactors,
  setUploadModal
) {
  if (!file) {
    setError({
      text: "Please upload a file",
      type: "feedback-error",
    });
    return;
  }

  if (file.name.split(".").pop() !== "xlsx") {
    setError({
      text: "Please upload a valid Excel file",
      type: "feedback-error",
    });
    return;
  }

  setError({
    text: tranStr("Uploading..."),
    type: "feedback-success",
  });

  const payload = {
    region: region,
    country: country,
    sourceType: "Location Factors",
  };

  const formData = new FormData();
  formData.append("file", file);
  formData.append("field", JSON.stringify(payload));

  const url = sharedAPIs().upload_location_factors;
  const config = {
    method: "POST",
    body: formData,
    headers: authHeader({
      authJson: false,
      authForm: true,
      guestJson: false,
    }),
  };

  let response = await fetch(url, config);
  if (response.ok) {
    locationFactors.set(await locationFactors.get());
    AutoCloseModal(setUploadModal);

    return setError({
      text: "Uploaded Successfully",
      type: "feedback-success",
    });
  } else {
    // Response Not OK
    await response.json().then((errorData) => {
      errorData.map((error) => {
        return setError({
          text: tranStr(error.reason.message),
          type: "feedback-error",
        });
      });
    });
  }
}
